"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const cookiePurposes = [{
  id: "essential",
  title: "Core Infrastructure",
  description: "These essential protocols are fundamentally required for the secure operation of our platform, enabling critical features such as secure authentication, transaction integrity, and session management."
}, {
  id: "performance",
  title: "Diagnostic Analytics",
  description: "We utilize performance metrics to analyze user journeys and system efficiency, allowing our engineering team to continuously optimize the speed, reliability, and delivery of our market intelligence."
}, {
  id: "functional",
  title: "Preference Memory",
  description: "Functional cookies preserve your customized dashboard settings, regional preferences, and saved filters to provide a consistent and personalized interface across your investment sessions."
}, {
  id: "targeting",
  title: "Strategic Engagement",
  description: "Targeting protocols allow us to deliver highly relevant market insights and investment opportunities that align with your professional interests and specific portfolio management goals."
}];
export default function PurposeOfCookies() {
  return <section data-section-id="154709" id="cookie-policy" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight mb-4 text-primary">
            Cookie Classification
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Our digital architecture employs sophisticated data protocols to ensure the security, efficiency, and personalization of your professional investment experience.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {cookiePurposes.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="border border-primary/20 rounded-lg overflow-hidden group/item transition-all duration-300 data-[state=open]:bg-card/40 data-[state=open]:backdrop-blur-md data-[state=open]:shadow-xl data-[state=open]:border-primary/60 hover:border-primary/40">
              <AccordionTrigger className="group [&>svg]:hidden hover:no-underline px-6 py-5 transition-all duration-300 outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
                <div className="flex items-center justify-between w-full text-left gap-4">
                  <span className="font-default font-semibold text-lg tracking-tight text-foreground group-data-[state=open]/item:text-primary transition-colors duration-300">
                    {item.title}
                  </span>
                  <Plus strokeWidth={2} strokeLinecap="square" strokeLinejoin="miter" className="size-5 shrink-0 text-muted-foreground group-data-[state=open]/item:text-primary transition-all duration-300 group-data-[state=open]/item:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 pt-0">
                <p className="text-base leading-relaxed font-default text-chart-4">
                  {item.description}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}